import RouteView from "../../../Routes/RouteView";
import OpsNavOptions, {defaultRoute} from "./OpsNavOptions";
const Ops=({navoption, ModalAction, data})=>{
    return(
        <RouteView navoption={navoption} ModalAction={ModalAction} defaultRoute={defaultRoute}>{OpsNavOptions}</RouteView>
        )
}
export default Ops;